<template>
  <el-row class="text">
    <div class="line"></div>
    <div class="title">
      <div class="title_1">{{ name }}</div>
      <div class="title_2">{{ letter }}</div>
    </div>
    <div class="line"></div>
  </el-row>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    letter: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
.text {
  display: flex;
  justify-content: center;
  margin: 0 0 50px;  
  .line {
    width: 172px;
    height: 4px;
    background: #949494;
    position: relative;
    top: 45px;
  }
  .title {
    margin: 0 30px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #454545;
    .title_1 {
      font-size: 36px;
      margin-bottom: 10px;
    }
    .title_2 {
      font-size: 16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/title.vue